export const translations = {
  "en": {
    "common": {
      "refresh": "Refresh",
      "loading": "Loading...",
      "showing": "Showing",
      "to": "to",
      "of": "of",
      "results": "results",
      "manage": "Manage",
      "edit": "Edit",
      "save": "Save Changes",
      "cancel": "Cancel",
      "close": "Close",
      "active": "Active",
      "inactive": "Inactive",
      "search": "Search",
      "filters": "Filters",
      "clearAll": "Clear All",
      "page": "Page",
      "previous": "Previous",
      "next": "Next",
      "status": "Status",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "all": "All",
      "allBanks": "All Banks",
      "allStatuses": "All Statuses",
      "copied": "Copied",
      "copy": "Copy",
      "language": "Language",
      "selectLanguage": "Select Language",
      "logout": "Log Out",
      "admin": "Admin",
      "operator": "Operator"
    },
    "auth": {
      "loginTitle": "Auto Deposit Control Hub",
      "loginSubtitle": "Sign in to access bank parser rules & inbound transactions",
      "username": "Username",
      "usernamePlaceholder": "Enter username (e.g. autodepositadmin)",
      "password": "Password",
      "passwordPlaceholder": "Enter password",
      "signIn": "Sign In to Dashboard",
      "signingIn": "Authenticating...",
      "loginSuccess": "Welcome back, {name}!",
      "loginFailed": "Invalid username or password.",
      "requiredUsername": "Username is required",
      "requiredPassword": "Password is required",
      "sessionExpired": "Session expired. Please sign in again.",
      "loggedAs": "Signed in as",
      "logout": "Log Out"
    },
    "nav": {
      "inboundMessages": "Inbound Messages",
      "bankRules": "Bank Regex Rules",
      "sandbox": "Live Regex Sandbox",
      "availableChannels": "Available Channels",
      "engineActive": "Engine Active"
    },
    "inbound": {
      "title": "Inbound Deposit Management",
      "subtitle": "Monitor incoming bank notifications & configure dynamic regex parser rules",
      "hubTitle": "Auto-Deposit Control Hub",
      "hubSubtitle": "Real-time parsing pipeline from SMS & LINE noti directly to CMS transactions",
      "searchPlaceholder": "Search by raw text, sender, account digits (e.g. 3122), token, or dedupe key...",
      "tabMatched": "Matched Bank Messages",
      "tabMatchedDesc": "(Known bank from sender)",
      "tabUnmatched": "Unmatched Bank Senders",
      "tabUnmatchedDesc": "(Sender not matching any bank)",
      "unmatchedAlertTitle": "Unmatched Bank Senders Bucket",
      "unmatchedAlertDesc": "These notifications could not be automatically matched with any known bank sender or keyword. Use the Quick Rule button to link the sender format to a bank.",
      "noMatched": "No matched bank messages found.",
      "noUnmatched": "🎉 Great! No unmatched or unparsed messages found.",
      "filters": {
        "agent": "Agent",
        "agentPlaceholder": "Select agent",
        "searchAgentPlaceholder": "Search agent prefix or name...",
        "noAgentsFound": "No agents found",
        "allAgents": "All Agents",
        "loadMore": "Load more...",
        "senderBank": "Sender Bank",
        "senderBankPlaceholder": "Select sender bank",
        "allSenderBanks": "All Sender Banks",
        "receiverBank": "Receiver Bank (CMS Bank)",
        "receiverBankPlaceholder": "Select receiver bank",
        "allReceiverBanks": "All Receiver Banks",
        "playerUsername": "Player Username",
        "playerUsernamePlaceholder": "Search player username...",
        "status": "Match Status",
        "statusPlaceholder": "Select status",
        "allStatus": "All Statuses",
        "createdDateRange": "Transaction Date Range",
        "clearAll": "Clear All Filters",
        "activeFilter": "Active Filters:"
      },
      "columns": {
        "createdAt": "Created At",
        "status": "Status",
        "bank": "Bank",
        "senderBank": "Sender Bank",
        "senderBankLogo": "Sender Bank",
        "senderName": "Sender Name",
        "senderAccountNumber": "Sender Account No.",
        "senderAccountName": "Sender Account Name",
        "senderAccount": "Sender Account",
        "playerUsername": "Player Username",
        "bankSender": "Bank Sender (Sender)",
        "sender": "Bank Sender (Sender)",
        "channel": "Bank Sender (Sender)",
        "amount": "Amount",
        "playerBank": "Player Bank",
        "agentPrefix": "Agent",
        "receiverBank": "Receiver Bank",
        "receiverBankLogo": "Receiver Bank",
        "receiverAccountNumber": "Receiver Account No.",
        "receiverAccountName": "Receiver Account Name",
        "receiverAccount": "Receiver Account",
        "bankReceiver": "Bank Receiver (CMS Bank)",
        "targetBank": "Bank Receiver (CMS Bank)",
        "matchedTx": "Matched Transaction Number",
        "copiedTx": "Copied transaction number",
        "copiedUsername": "Copied player username",
        "manage": "Manage",
        "rawMessage": "Raw Message"
      },
      "statuses": {
        "matched": "MATCHED",
        "parsed": "PARSED",
        "pending": "PENDING",
        "unparsed": "UNPARSED",
        "duplicate": "DUPLICATE",
        "failed": "FAILED",
        "unknown": "UNKNOWN"
      },
      "inspectModal": {
        "title": "Inbound Message Raw Inspector",
        "sendBank": "Send Bank",
        "receiveBank": "Receive Bank",
        "senderAccount": "Sender Account",
        "receiveAccount": "Receive Account",
        "bankDetected": "Bank Detected",
        "extractedAmount": "Extracted Amount",
        "transferTime": "Transfer Timestamp",
        "rawText": "Raw Notification Text"
      }
    },
    "rules": {
      "title": "Bank Regex Rules Configuration",
      "subtitle": "Configure dynamic regex patterns and sender aliases for all Thai banks in DB",
      "hubTitle": "Thai Banks Dynamic Regex Rules",
      "hubSubtitle": "Manage SMS sender aliases, LINE OA keywords, and account extraction regex patterns for each bank",
      "noRules": "No bank rules found.",
      "statusUpdated": "Rule status for {name} updated to {status}",
      "statusFailed": "Failed to update status",
      "editRule": "Edit Bank Regex Rule",
      "columns": {
        "bank": "Bank",
        "bankExtractor": "Bank Extractor",
        "receiveExtractor": "Receive Money Extractor",
        "accountFormat": "Account Format",
        "priority": "Priority",
        "status": "Status",
        "actions": "Actions",
        "manage": "Manage",
        "viewAll": "View all",
        "keywordsCount": "keywords"
      },
      "editModal": {
        "title": "Edit Parser Rule — {name} ({prefix})",
        "subtitle": "Configure Bank & Receive Extractor regex patterns, account formats, and test against sample text",
        "bankExtractorSection": "Bank Extractor (Keywords & Regex)",
        "bankExtractorHelp": "Specify regex keywords, Thai bank names, or channel tags to detect this bank (e.g. SCB|ไทยพาณิชย์|SCB Connect|SCBA).",
        "receiveExtractorSection": "Receive Money Extractor (Incoming Deposit Keywords)",
        "receiveExtractorHelp": "Specify regex keywords or phrases indicating incoming money/deposits (e.g. เงินเข้า|รับเงิน|รับโอน|โอนเงินเข้า|เข้าบัญชี|deposit|+).",
        "patternSelection": "Account Number Format Pattern",
        "patternHelp": "Select the visual format matching how this bank masks account numbers in notifications:",
        "presetUniversal": "Smart Universal (All Patterns)",
        "presetUniversalDesc": "Handles middle mask, segmented, prefix, suffix, dots, and บ/ช (Recommended)",
        "presetMiddleMask": "Middle Mask (3852xxx667)",
        "presetMiddleMaskDesc": "E.g. 3852xxx667, 4124XXX781 (Bangkok Bank BBL, SCB)",
        "presetSegmentedMask": "Segmented Mask (xxx-x-1234-x)",
        "presetSegmentedMaskDesc": "E.g. xxx-x-8357-x, xxx-x-1234-x (TTB, TMB, Thanachart)",
        "presetMaskedPrefix": "Masked Prefix (x- / XX / xxx-1234)",
        "presetMaskedPrefixDesc": "Matches prefix masking with 1-3 letters or hyphens, e.g. x-3122, XX7219, xxx-123 (KBANK, SCB, BAY, BAAC, UOB)",
        "presetMaskedSuffix": "Masked Suffix (1234-xxx)",
        "presetMaskedSuffixDesc": "E.g. 123-xxx, 4567-xxx (SCB Connect, Krungsri)",
        "presetDots": "Ellipsis Format (...1234)",
        "presetDotsDesc": "E.g. ...4321, ...8877 (Krungthai, MyMo, GHB)",
        "presetFullDigits": "Full Account (10-12 Digits)",
        "presetFullDigitsDesc": "Full unmasked bank account numbers",
        "presetCustom": "Custom Advanced Regex",
        "presetCustomDesc": "Manually write raw regex patterns with capture groups",
        "accountRegexSection": "Custom Account Extraction Regex",
        "amountRegex": "Amount Extraction Mode",
        "standardAmount": "Standard Thai Baht (e.g. 1,200.00 บาท, ฿500, 1,000 THB)",
        "customAmount": "Custom Amount Regex Pattern",
        "dateRegex": "Timestamp Regex Pattern",
        "sampleWorkbench": "Live Test Workbench (Sample SMS)",
        "sampleHelp": "Type or paste a sample SMS/LINE notification to see live extraction results instantly.",
        "runTest": "Run Test Extraction",
        "bankDetected": "Bank Detected",
        "extractedAmount": "Extracted Amount",
        "extractedAccount": "Extracted Account",
        "extractedTime": "Extracted Time",
        "saveSuccess": "Parser rule for {prefix} updated successfully!"
      }
    },
    "sandbox": {
      "title": "Live Regex Sandbox Workbench",
      "subtitle": "Simulate and test bank notification parsing algorithms in real-time with sample SMS and custom regex",
      "hubTitle": "Real-time SMS & LINE Regex Tester",
      "hubSubtitle": "Paste raw notification text to test bank detection, amount extraction, and account patterns instantly",
      "presets": "Quick Test Presets (Thai Bank Templates)",
      "rawLabel": "Raw SMS / Notification Message Text",
      "senderLabel": "Sender Header / Channel Name",
      "targetMode": "Target Bank Match Mode",
      "autoDetect": "⚡ Auto-Detect Bank from Keywords",
      "executeButton": "Execute Extraction Test",
      "resultsTitle": "Extraction Results Preview",
      "detectedBank": "Detected Bank",
      "parsedAmount": "Parsed Amount",
      "senderDigits": "Sender Account Digits",
      "transferTime": "Transfer Timestamp",
      "clickPrompt": "Click Execute to see live extraction tokens",
      "matchedSuccess": "Pattern matched successfully",
      "noMatchWarning": "No matching bank or regex rule found",
      "forceBankLabel": "Force Target Bank",
      "inputLabel": "Notification Text",
      "customRegexOverride": "Advanced Custom Regex Override",
      "runTestBtn": "Run Extraction Test",
      "sendBank": "Send Bank",
      "receiveBank": "Receive Bank",
      "receiveAccount": "Receive Account",
      "extractedBank": "Detected Bank",
      "extractedAmount": "Extracted Amount",
      "extractedAccount": "Sender Account",
      "extractedTime": "Extracted Time"
    },
    "channels": {
      "title": "Available Channels",
      "subtitle": "Real-time bank channel support matrix for inbound deposits and outbound withdrawals",
      "hubTitle": "System Channels Matrix",
      "hubSubtitle": "Click any cell to toggle channel availability in real time across the entire platform",
      "bankColumn": "Bank",
      "depositHeader": "Inbound / Deposit",
      "withdrawHeader": "Outbound / Withdraw",
      "depositTitle": "ขาฝาก",
      "withdrawTitle": "ขาถอน",
      "depositSection": "Deposit Channels (ขาฝาก)",
      "withdrawSection": "Withdraw Channels (ขาถอน)",
      "searchPlaceholder": "Search by bank name or code (e.g. SCB, KBANK)...",
      "bannerInfo": "Changes made here affect all banks system-wide across all tenants.",
      "lineAutoDigits": "Line Auto Digits",
      "channelNames": {
        "api": "API",
        "sms": "SMS",
        "notiApp": "NotiApp",
        "email": "Email",
        "promptpay": "พร้อมเพย์",
        "line": "LINE",
        "webhook": "Webhook",
        "web": "Web",
        "withdrawApi": "API",
        "autoclick": "Autoclick"
      },
      "corporate": "Corporate Account",
      "toggleSuccess": "Updated {channel} for {bank}",
      "toggleFailed": "Failed to update channel",
      "noChannels": "No channel configurations found",
      "pagination": {
        "show": "Show",
        "entries": "entries",
        "showing": "Showing",
        "to": "to",
        "of": "of"
      }
    }
  },
  "th": {
    "common": {
      "refresh": "รีเฟรช",
      "loading": "กำลังโหลด...",
      "showing": "แสดง",
      "to": "ถึง",
      "of": "จากทั้งหมด",
      "results": "รายการ",
      "manage": "จัดการ",
      "edit": "แก้ไข",
      "save": "บันทึกการเปลี่ยนแปลง",
      "cancel": "ยกเลิก",
      "close": "ปิด",
      "active": "เปิดใช้งาน",
      "inactive": "ปิดใช้งาน",
      "search": "ค้นหา",
      "filters": "ตัวกรอง",
      "clearAll": "ล้างทั้งหมด",
      "page": "หน้า",
      "previous": "ก่อนหน้า",
      "next": "ถัดไป",
      "status": "สถานะ",
      "dateFrom": "ตั้งแต่วันที่",
      "dateTo": "ถึงวันที่",
      "all": "ทั้งหมด",
      "allBanks": "ทุกธนาคาร",
      "allStatuses": "ทุกสถานะ",
      "copied": "คัดลอกแล้ว",
      "copy": "คัดลอก",
      "language": "ภาษา",
      "selectLanguage": "เลือกภาษา",
      "logout": "ออกจากระบบ",
      "admin": "ผู้ดูแลระบบ",
      "operator": "เจ้าหน้าที่"
    },
    "auth": {
      "loginTitle": "ระบบจัดการเงินเข้าอัตโนมัติ",
      "loginSubtitle": "เข้าสู่ระบบเพื่อจัดการกฎ Regex และตรวจสอบข้อความเงินเข้า",
      "username": "ชื่อผู้ใช้งาน",
      "usernamePlaceholder": "กรอกชื่อผู้ใช้งาน (เช่น autodepositadmin)",
      "password": "รหัสผ่าน",
      "passwordPlaceholder": "กรอกรหัสผ่าน",
      "signIn": "เข้าสู่ระบบ",
      "signingIn": "กำลังเข้าสู่ระบบ...",
      "loginSuccess": "ยินดีต้อนรับ, {name}!",
      "loginFailed": "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง",
      "requiredUsername": "กรุณากรอกชื่อผู้ใช้งาน",
      "requiredPassword": "กรุณากรอกรหัสผ่าน",
      "sessionExpired": "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
      "loggedAs": "เข้าสู่ระบบในชื่อ",
      "logout": "ออกจากระบบ"
    },
    "nav": {
      "inboundMessages": "ข้อความเงินเข้า (ถังกลาง)",
      "bankRules": "ตั้งค่า Regex ธนาคาร",
      "sandbox": "ทดสอบ Regex (Sandbox)",
      "availableChannels": "ช่องทางที่รองรับ",
      "engineActive": "ระบบทำงานปกติ"
    },
    "inbound": {
      "title": "จัดการข้อความเงินเข้าอัตโนมัติ",
      "subtitle": "ตรวจสอบการแจ้งเตือนเงินเข้าจากธนาคาร และจัดการ Regex ถอดรหัสบัญชี/ยอดเงิน",
      "hubTitle": "ศูนย์ควบคุมการประมวลผลเงินเข้าอัตโนมัติ",
      "hubSubtitle": "แปลงข้อความ SMS และ LINE แจ้งเตือนเข้าสู่ระบบธุรกรรม CMS แบบเรียลไทม์",
      "searchPlaceholder": "ค้นหาตามข้อความดิบ, ผู้ส่ง, เลขบัญชี (เช่น 3122), โทเค็น, หรือคีย์อ้างอิง...",
      "tabMatched": "ข้อความที่ระบุธนาคารได้",
      "tabMatchedDesc": "(รู้ธนาคารจากผู้ส่ง)",
      "tabUnmatched": "ผู้ส่งที่ไม่ตรงกับธนาคารใดๆ",
      "tabUnmatchedDesc": "(ต้องกำหนดค่าผู้ส่งใหม่)",
      "unmatchedAlertTitle": "ถังข้อความที่ไม่ตรงกับธนาคารใดๆ",
      "unmatchedAlertDesc": "ข้อความเหล่านี้ไม่ตรงกับชื่อผู้ส่งหรือคีย์เวิร์ดของธนาคารใดๆ สามารถกดปุ่ม Quick Rule เพื่อผูกผู้ส่งกับธนาคารได้ทันที",
      "noMatched": "ไม่พบรายการข้อความเงินเข้าที่ตรงกับเงื่อนไข",
      "noUnmatched": "🎉 เยี่ยมมาก! ไม่พบข้อความที่ถอดรหัสไม่ผ่าน",
      "filters": {
        "agent": "เอเย่นต์",
        "agentPlaceholder": "เลือกเอเย่นต์",
        "searchAgentPlaceholder": "ค้นหาคำนำหน้าหรือชื่อเอเย่นต์...",
        "noAgentsFound": "ไม่พบเอเย่นต์",
        "allAgents": "เอเย่นต์ทั้งหมด",
        "loadMore": "โหลดเพิ่มเติม...",
        "senderBank": "ธนาคารผู้โอน",
        "senderBankPlaceholder": "เลือกธนาคารผู้โอน",
        "allSenderBanks": "ธนาคารผู้โอนทั้งหมด",
        "receiverBank": "ธนาคารผู้รับ (CMS Bank)",
        "receiverBankPlaceholder": "เลือกธนาคารผู้รับ",
        "allReceiverBanks": "ธนาคารผู้รับทั้งหมด",
        "playerUsername": "ยูสเซอร์ผู้เล่น",
        "playerUsernamePlaceholder": "ค้นหายูสเซอร์ผู้เล่น...",
        "status": "สถานะการจับคู่",
        "statusPlaceholder": "เลือกสถานะ",
        "allStatus": "ทุกสถานะ",
        "createdDateRange": "วันที่ทำรายการ (ช่วงเวลา)",
        "clearAll": "ล้างตัวกรองทั้งหมด",
        "activeFilter": "ตัวกรองที่เลือก:"
      },
      "columns": {
        "createdAt": "วันที่ทำรายการ",
        "status": "สถานะ",
        "bank": "ธนาคาร",
        "senderBank": "ธนาคารผู้โอน",
        "senderBankLogo": "ธนาคารผู้โอน",
        "senderName": "ชื่อผู้ส่ง (Sender)",
        "senderAccountNumber": "เลขบัญชีผู้โอน",
        "senderAccountName": "ชื่อบัญชีผู้โอน",
        "senderAccount": "บัญชีผู้โอน",
        "playerUsername": "ยูสเซอร์ผู้เล่น",
        "bankSender": "ธนาคารผู้โอน (Sender)",
        "sender": "ธนาคารผู้โอน (Sender)",
        "channel": "ธนาคารผู้โอน (Sender)",
        "amount": "ยอดเงิน",
        "playerBank": "ธนาคารผู้เล่น",
        "agentPrefix": "เอเย่นต์",
        "receiverBank": "ธนาคารผู้รับ",
        "receiverBankLogo": "ธนาคารผู้รับ",
        "receiverAccountNumber": "เลขบัญชีผู้รับ",
        "receiverAccountName": "ชื่อบัญชีผู้รับ (CMS)",
        "receiverAccount": "บัญชีผู้รับ (CMS)",
        "bankReceiver": "ธนาคารผู้รับ (CMS Bank)",
        "targetBank": "ธนาคารผู้รับ (CMS Bank)",
        "matchedTx": "เลขธุรกรรมที่จับคู่",
        "copiedTx": "คัดลอกเลขธุรกรรมแล้ว",
        "copiedUsername": "คัดลอกยูสเซอร์ผู้เล่นแล้ว",
        "manage": "จัดการ",
        "rawMessage": "ข้อความดิบ"
      },
      "statuses": {
        "matched": "จับคู่สำเร็จ",
        "parsed": "ถอดรหัสแล้ว",
        "pending": "รอดำเนินการ",
        "unparsed": "ถอดรหัสไม่ได้",
        "duplicate": "ข้อความซ้ำ",
        "failed": "ล้มเหลว",
        "unknown": "ไม่ทราบธนาคาร"
      },
      "inspectModal": {
        "title": "ตรวจสอบข้อความดิบ (Raw Inspector)",
        "sendBank": "ธนาคารผู้โอน (Send Bank)",
        "receiveBank": "ธนาคารผู้รับ (Receive Bank)",
        "senderAccount": "เลขบัญชีผู้โอน",
        "receiveAccount": "เลขบัญชีผู้รับ",
        "bankDetected": "ธนาคารที่ตรวจพบ",
        "extractedAmount": "ยอดเงินที่สกัดได้",
        "transferTime": "เวลาที่โอน",
        "rawText": "ข้อความการแจ้งเตือนดิบ"
      }
    },
    "rules": {
      "title": "ตั้งค่า Regex และชื่อผู้ส่งของธนาคาร",
      "subtitle": "จัดการรูปแบบ Regex ถอดรหัสเลขบัญชีและชื่อผู้ส่ง SMS/LINE สำหรับทุกธนาคารในระบบ",
      "hubTitle": "กฎการถอดรหัส Regex ธนาคารไทย",
      "hubSubtitle": "กำหนดชื่อผู้ส่ง SMS, บัญชีทางการ LINE OA และรูปแบบ Regex การสกัดเลขบัญชีสำหรับแต่ละธนาคาร",
      "noRules": "ไม่พบข้อมูลกฎของธนาคาร",
      "statusUpdated": "อัปเดตสถานะของ {name} เป็น {status} เรียบร้อยแล้ว",
      "statusFailed": "ไม่สามารถอัปเดตสถานะได้",
      "editRule": "แก้ไขกฎ Regex ของธนาคาร",
      "columns": {
        "bank": "ธนาคาร",
        "bankExtractor": "ตัวตรวจจับธนาคาร (Bank Extractor)",
        "receiveExtractor": "ตัวตรวจจับเงินเข้า (Receive Extractor)",
        "accountFormat": "รูปแบบบัญชี",
        "priority": "ลำดับความสำคัญ",
        "status": "สถานะ",
        "actions": "จัดการ",
        "manage": "จัดการ",
        "viewAll": "ดูทั้งหมด",
        "keywordsCount": "คีย์เวิร์ด"
      },
      "editModal": {
        "title": "แก้ไขกฎการถอดรหัส — {name} ({prefix})",
        "subtitle": "ตั้งค่าคำสั่ง Regex ตรวจจับธนาคาร, ตรวจจับเงินเข้า, รูปแบบเลขบัญชี และทดสอบกับข้อความตัวอย่าง",
        "bankExtractorSection": "ตัวตรวจจับธนาคาร (Bank Extractor)",
        "bankExtractorHelp": "ระบุคีย์เวิร์ด Regex, ชื่อภาษาไทย หรือชื่อ LINE OA เพื่อตรวจจับธนาคารนี้ (เช่น SCB|ไทยพาณิชย์|SCB Connect|SCBA)",
        "receiveExtractorSection": "ตัวตรวจจับเงินเข้า (Receive Money Extractor)",
        "receiveExtractorHelp": "ระบุคีย์เวิร์ด Regex หรือคำบ่งชี้รายการเงินเข้า/รับโอน (เช่น เงินเข้า|รับเงิน|รับโอน|โอนเงินเข้า|เข้าบัญชี|deposit|+)",
        "patternSelection": "รูปแบบการซ่อนเลขบัญชีของผู้ส่ง",
        "patternHelp": "เลือกรูปแบบหน้าตาของเลขบัญชีที่ธนาคารนี้ใช้ในข้อความแจ้งเตือน:",
        "presetUniversal": "ครอบคลุมทุกรูปแบบ (แนะนำ)",
        "presetUniversalDesc": "รองรับทั้งซ่อนกลาง, ซ่อนแยกส่วน, ซ่อนหน้า, ซ่อนท้าย, จุดไข่ปลา และ บ/ช (แนะนำ)",
        "presetMiddleMask": "ซ่อนตรงกลาง (3852xxx667)",
        "presetMiddleMaskDesc": "เช่น 3852xxx667, 4124XXX781 (ธ.กรุงเทพ BBL, SCB)",
        "presetSegmentedMask": "ซ่อนแบบแยกส่วน (xxx-x-8357-x)",
        "presetSegmentedMaskDesc": "เช่น xxx-x-8357-x, xxx-x-1234-x (ทีทีบี TTB, TMB)",
        "presetMaskedPrefix": "ซ่อนหน้าบัญชี (x- / XX / xxx-1234)",
        "presetMaskedPrefixDesc": "ครอบคลุมการซ่อนเลขหน้าทุกแบบทั้ง x-3122, XX7219, xxx-123 (กสิกร, SCB, กรุงศรี, ธ.ก.ส., ยูโอบี)",
        "presetMaskedSuffix": "ซ่อนท้ายบัญชี (1234-xxx)",
        "presetMaskedSuffixDesc": "เช่น 123-xxx, 4567-xxx (SCB Connect, กรุงศรี)",
        "presetDots": "จุดไข่ปลา (...1234)",
        "presetDotsDesc": "เช่น ...4321, ...8877 (กรุงไทย, MyMo, ธอส.)",
        "presetFullDigits": "เลขบัญชีเต็ม (10-12 หลัก)",
        "presetFullDigitsDesc": "เลขบัญชีที่ไม่ถูกซ่อนด้วย x หรือ *",
        "presetCustom": "ปรับแต่ง Regex ขั้นสูงเอง",
        "presetCustomDesc": "เขียนคำสั่ง Regular Expression ด้วยตนเอง",
        "accountRegexSection": "คำสั่ง Regex สกัดเลขบัญชี",
        "amountRegex": "โหมดการสกัดยอดเงิน",
        "standardAmount": "ยอดเงินบาทมาตรฐาน (เช่น 1,200.00 บาท, ฿500, 1,000 THB)",
        "customAmount": "กำหนดคำสั่ง Regex ยอดเงินเอง",
        "dateRegex": "Regex สกัดวันที่และเวลา",
        "sampleWorkbench": "พื้นที่ทดสอบสด (ข้อความตัวอย่าง)",
        "sampleHelp": "พิมพ์หรือวางข้อความ SMS/LINE ตัวอย่างเพื่อดูผลลัพธ์การสกัดข้อมูลได้ทันที",
        "runTest": "ทดสอบการสกัดข้อมูล",
        "bankDetected": "ธนาคารที่ตรวจพบ",
        "extractedAmount": "ยอดเงินที่สกัดได้",
        "extractedAccount": "เลขบัญชีที่สกัดได้",
        "extractedTime": "เวลาที่สกัดได้",
        "saveSuccess": "บันทึกกฎของ {prefix} เรียบร้อยแล้ว!"
      }
    },
    "sandbox": {
      "title": "พื้นที่ทดสอบ Regex แบบสด (Sandbox)",
      "subtitle": "จำลองและทดสอบอัลกอริทึมการถอดรหัสข้อความธนาคารแบบเรียลไทม์ พร้อมตัวอย่างข้อความ SMS",
      "hubTitle": "เครื่องมือทดสอบ Regex ข้อความ SMS & LINE",
      "hubSubtitle": "วางข้อความการแจ้งเตือนดิบเพื่อทดสอบการระบุธนาคาร ยอดเงิน และเลขบัญชีผู้โอนได้ทันที",
      "presets": "ตัวอย่างข้อความธนาคารไทย (Presets)",
      "rawLabel": "ข้อความ SMS / การแจ้งเตือนดิบ",
      "senderLabel": "ชื่อผู้ส่ง / ช่องทาง (Sender)",
      "targetMode": "โหมดการจับคู่ธนาคาร",
      "autoDetect": "⚡ ตรวจหาธนาคารอัตโนมัติจากคีย์เวิร์ด",
      "executeButton": "เริ่มทดสอบการถอดรหัส",
      "resultsTitle": "ผลลัพธ์การสกัดข้อมูล",
      "detectedBank": "ธนาคารที่ตรวจพบ",
      "parsedAmount": "ยอดเงินที่สกัดได้",
      "senderDigits": "เลขบัญชีผู้โอน",
      "transferTime": "เวลาที่โอนเงิน",
      "clickPrompt": "กดปุ่มเริ่มทดสอบเพื่อดูข้อมูลที่สกัดได้",
      "matchedSuccess": "ถอดรหัสข้อความสำเร็จ",
      "noMatchWarning": "ไม่พบกฎหรือธนาคารที่ตรงกัน",
      "forceBankLabel": "กำหนดธนาคารเป้าหมาย",
      "inputLabel": "ข้อความการแจ้งเตือน",
      "customRegexOverride": "ปรับแต่งคำสั่ง Regex พิเศษ",
      "runTestBtn": "ทดสอบการสกัดข้อมูล",
      "sendBank": "ธนาคารผู้โอน (Send Bank)",
      "receiveBank": "ธนาคารผู้รับ (Receive Bank)",
      "receiveAccount": "เลขบัญชีผู้รับ",
      "extractedBank": "ธนาคารที่ตรวจพบ",
      "extractedAmount": "ยอดเงินที่สกัดได้",
      "extractedAccount": "เลขบัญชีผู้โอน",
      "extractedTime": "เวลาที่สกัดได้"
    },
    "channels": {
      "title": "ช่องทางที่รองรับ",
      "subtitle": "ภาพรวมและกำหนดค่าช่องทางฝาก-ถอนที่ระบบรองรับสำหรับแต่ละธนาคาร",
      "hubTitle": "ตารางสถานะช่องทางของระบบ (System Channels Matrix)",
      "hubSubtitle": "คลิกที่ช่องเพื่อเปิด/ปิดการใช้งานช่องทางแบบ Real-time ทั่วทั้งระบบ",
      "bankColumn": "ธนาคาร",
      "depositHeader": "ขาฝาก",
      "withdrawHeader": "ขาถอน",
      "depositTitle": "ขาฝาก",
      "withdrawTitle": "ขาถอน",
      "depositSection": "ขาฝาก (Deposit)",
      "withdrawSection": "ขาถอน (Withdraw)",
      "searchPlaceholder": "ค้นหาตามชื่อธนาคาร, รหัส (เช่น SCB, กสิกร)...",
      "bannerInfo": "การตั้งค่าในหน้านี้จะมีผลกับทุกธนาคารทั่วทั้งระบบของทุกเอเย่นต์",
      "lineAutoDigits": "ไลน์ทศนิยม",
      "channelNames": {
        "api": "API",
        "sms": "SMS",
        "notiApp": "NotiApp",
        "email": "Email",
        "promptpay": "พร้อมเพย์",
        "line": "LINE",
        "webhook": "Webhook",
        "web": "Web",
        "withdrawApi": "API",
        "autoclick": "Autoclick"
      },
      "corporate": "บัญชีนิติบุคคล",
      "toggleSuccess": "อัปเดตช่องทาง {channel} ของ {bank} สำเร็จ",
      "toggleFailed": "เกิดข้อผิดพลาดในการอัปเดตช่องทาง",
      "noChannels": "ไม่พบข้อมูลช่องทางธนาคาร",
      "pagination": {
        "show": "แสดง",
        "entries": "รายการ",
        "showing": "แสดง",
        "to": "ถึง",
        "of": "จากทั้งหมด"
      }
    }
  }
};

export type Language = 'en' | 'th';

export function getTranslation(
  lang: Language,
  key: string,
  params?: Record<string, string | number>
): string {
  const keys = key.split('.');
  const dictionary = translations[lang] ?? translations.en;
  let value: any = dictionary;

  for (const k of keys) {
    value = value?.[k];
  }

  let translation = value || key;

  if (params && typeof translation === 'string') {
    Object.entries(params).forEach(([paramKey, paramValue]) => {
      translation = translation.replace(
        new RegExp("{" + paramKey + "}", 'g'),
        String(paramValue)
      );
    });
  }

  return translation;
}
